
export default {
  props: {
    item: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    image: {
      borderRadius: 'lg',
      borderWidth: 1,
      shadow: true,
      padding: 'md',
      width: 'lg',
      backgroundColor: 'white'
    }
  },
  computed: {
    itemPath() {
      return this.$pagePath(`/applications/${this.item.slug}`)
    }
  }
}
